import { AppRecord, AppRecordStatus } from "models/appRecord";
import { createSlice } from "@reduxjs/toolkit";

interface ProfileDetailSlice {
  professionalProfileState: AppRecord;
  profileViewState: AppRecord;
}

const initialState: ProfileDetailSlice = {
  professionalProfileState: {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  },

  profileViewState: {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  },
};

const profileDetailSlice = createSlice({
  name: "profileDetail",
  initialState,
  reducers: {
    setProfessionalProfileLoading(state, action) {
      state.professionalProfileState = action.payload;
    },

    setProfileViewLoading(state, action) {
      state.profileViewState = action.payload;
    },

    clearState() {
      return initialState;
    },
  },
});

export const {
  setProfessionalProfileLoading,
  setProfileViewLoading,
  clearState,
} = profileDetailSlice.actions;

const profileDetailReducer = profileDetailSlice.reducer;
export default profileDetailReducer;
